import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';
import { useLocale } from '@/modules/locale/model/locale';
import { challengeService } from '@/services/challenge';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useChallengeTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        id: route.params.id,
        locale: null,
        title: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_CHALLENGE.INDEX });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => challengeService.getContent(model.id, model.locale),
        onSuccess: ({ data }) => {
            model.title = data.title;
            model.hasData = true;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => challengeService.updateContent(model.id, model.locale, model.title),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => challengeService.removeContent(model.id, model.locale),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
